<template>
<div class="chapter">
<div class="inner_page">
<p class="TIT"><span epub:type="pagebreak" id="pg_1" title="1"><span href="#/xhtml/contents#p_bk1" title="Link target outside of Sample"><img alt="" class="img90" src="images/boomerBOOKONE.jpg"/></span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// book1.vue?2c52d959